import {MediaMatcher} from '@angular/cdk/layout';
import {ChangeDetectorRef,  Component, EventEmitter,  Inject,  Input,  LOCALE_ID,  OnDestroy,  OnInit,  Output,  ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Subject} from "rxjs";
import {Project} from "../../../../../model/Project";
import {StartupService} from "../../../../service-ui/startup.service";
import {ProjectService} from "../../../../service-data/project.service";
import {Util} from "../../../../util/Util";
import {Book} from "../../../../../model/Book";
import {Draft} from "../../../../../model/Draft";
import {DraftService} from "../../../../service-data/draft.service";
import {BookService} from "../../../../service-data/book.service";
import {MatDialog} from "@angular/material/dialog";
import {ConfirmDialogComponent} from "../../../confirm-dialog/confirm-dialog.component";
import {LanguagePipe} from "../../../../pipe/language.pipe";

@Component({
  selector: 'app-project-details',
  templateUrl: './project-details.component.html',
  styleUrls: ['./project-details.component.css']
})
export class ProjectDetailsComponent implements OnDestroy, OnInit {
  @ViewChild('placeHolderProjectName') placeHolderProjectName;
  @Input() project: Project;
  @Input() displayCover: boolean;
  @Input() editingDetails: string;
  @Output() editingDetailsChange = new EventEmitter<any>();

  protected readonly Util = Util;

  searchString: string;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  onDestroySubject: Subject<boolean> = new Subject();

  public renameProject: boolean = false;
  sizeWidth: 0;


  constructor(public router: Router, public startupService: StartupService, public changeDetectorRef: ChangeDetectorRef, public media: MediaMatcher, private projectService: ProjectService, private draftService: DraftService, private bookService: BookService, private dialog: MatDialog, private route: ActivatedRoute, @Inject(LOCALE_ID) localeId: string) {
    this.startupService.touchLastUserActivity();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  onDataChange() {
    this.editingDetailsChange.emit(this.editingDetails);
  }

  ngOnInit() {
  }

  onSubmit() {
  }

  onResize(event: any) {
    const w = event.target.innerWidth;
    this.sizeWidth = w;
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.onDestroySubject.next(true);
    this.onDestroySubject.unsubscribe();
  }

  isProjectNameUsed(): boolean {
    if (!this.placeHolderProjectName || !this.placeHolderProjectName.nativeElement || !this.placeHolderProjectName.nativeElement.value) {
      return true;
    }
    const newProjectName = this.placeHolderProjectName.nativeElement.value.trim();
    for (const project of this.projectService.objects) {
      if (newProjectName === project.name) {
        return true;
      }
    }
    return false;
  }

  /**
   * `updateItem` returns a COLD observable — `http.put(...)` does not issue
   * anything until something subscribes. This called it and dropped the
   * result, so renaming a Project from the details view has never sent a
   * request: the field updated on screen, nothing was persisted, and the old
   * name came back on the next load with no error anywhere.
   *
   * The sibling call sites in `classic-project-thumbnail.component.ts` both
   * subscribe, which is why the same action works from the tile.
   */
  saveProjectValue() {
    this.project.name = this.placeHolderProjectName.nativeElement.value;
    this.projectService.updateItem(this.project).subscribe();
  }

  cancelProjectValue() {
    this.placeHolderProjectName.nativeElement.value = this.project.name;
  }

  moveToNewProject(item: Draft | Book, draftOrBook: string) {
    if (draftOrBook === 'DRAFT') {
      const draft = item as Draft;
      this.projectService.createNewProjectWithDraft(draft.ID, draft.title).subscribe();
    } else {
      const book = item as Book;
      this.projectService.createNewProjectWithBook(book.ID, book.title).subscribe();
    }
  }

  moveToProject(item: Draft | Book, draftOrBook: string) {
    if (draftOrBook === 'DRAFT') {
      const draft = item as Draft;
      this.draftService.reassignProject(draft.ID, 0).subscribe();
    } else {
      const book = item as Book;
      this.projectService.moveBookToProject(book.ID, this.project.ID, 0).subscribe();
    }
  }

  makePrimary(item: Draft | Book, draftOrBook: string) {
    if (draftOrBook === 'DRAFT') {
      const draft = item as Draft;
      this.projectService.setDraftAsPrimary(this.project.ID, draft.ID).subscribe();
    } else {
      const book = item as Book;
      this.projectService.setBookAsPrimary(this.project.ID, book.ID).subscribe();
    }
  }

  delete(item: Draft | Book, draftOrBook: string) {
    const itemName = draftOrBook === 'DRAFT' ? (item as Draft).title : (item as Book).title;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: {
        name: itemName,
        title: LanguagePipe.get('Delete', 'compressSpaces') + ' ' + itemName + LanguagePipe.get('?', 'compressSpaces'),
        body: '',
        noButton: LanguagePipe.get('Cancel', 'compressSpaces'),
        yesButton: LanguagePipe.get('Delete', 'compressSpaces') + ' ' + itemName,
        returnValue: 'ok'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result === 'ok') {
        if (draftOrBook === 'DRAFT') {
          this.draftService.deleteItem(item as Draft).subscribe();
        } else {
          this.bookService.deleteItem(item as Book).subscribe();
        }
      }
    });
  }
}
